export default {
  /**
   *
   * @param state
   * @returns [{},{}]
   */
  groupsForSelect: state => state.groups.map(group => ({
    label: group.name,
    value: group.id,
  })),
};
